import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./App.css";
import Navbar from "./NavBar";
import { refreshAccessToken } from "./auth";

function YonetimPanel() {
  const [personnelList, setPersonnelList] = useState([]);
  const [selectedSicil, setSelectedSicil] = useState("");
  const [leaveReport, setLeaveReport] = useState([]);
  const [loadingLeaveReport, setLoadingLeaveReport] = useState([]);
  const[pendingLeaves,setPendingLeaves]= useState([]);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [loading_personnel, setLoading] = useState(true);
  const [user, setuser]=useState(null);

  useEffect(() => {
      async function init() {
        const success = await refreshAccessToken();
        if (!success) {
          console.log('Refresh failed, redirected to login.');
          return;
        }
    
        try {
          const res = await fetch('/me', { credentials: 'include' });
          const data = await res.json();
          if (res.ok) {
            if (data.sicil_no) {
              //setFormData((prevData) => ({ ...prevData, SICIL_NO: data.SICIL_NO }));
              setuser(data);
              //fetchIzinler(data);
            } else {
              console.error("Sicil bilgisi bulunamadı");
            }
          } else {
            console.error("User fetch error:", data.error);
          }
        } catch (err) {
          console.error("User fetch exception:", err);
        }
      }
    
      init();
    }, []);
  useEffect(() => {
    // Fetch personnel list on page load
    const fetchPersonnel = async () => {
      try {
        const response = await fetch("/personel_listesi");
        if (!response.ok) {
            const text = await response.text();
            throw new Error(text || "Personel listesi alınamadı");
          }
          const data = await response.json();
        setPersonnelList(data);
        setLoading(false); //personel yükleme tamam
      } catch (err) {
        setError(err.message);
      }
    };
    fetchPersonnel();
  }, []);

  const fetchPendingLeaves = async (sicilNo) => {
    try {
        const response = await fetch(`/bekleyen_izin_personel/${sicilNo}`);
        
        if (!response.ok) {
            const text = await response.text();
            throw new Error(text || "Bekleyen izinler alınamadı");
          }
          const data = await response.json();
          setPendingLeaves(data);

    }catch (err) {
        setError(err.message);
      }
  };

  const fetchLeaveReport = async (sicilNo) => {
    setLoadingLeaveReport(true);
    try {
      const response = await fetch(`/izin_rapor/${sicilNo}`);
      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || "İzin kayıtları alınamadı");
      }
      const data = await response.json();

      setLeaveReport(data);
    } catch (err) {
      setError(err.message);
    }finally{setLoadingLeaveReport(false);}
    
  };

  useEffect(() => {
    // Fetch leave report when a personnel is selected
    if (selectedSicil) {
      
      fetchLeaveReport(selectedSicil);
      
      fetchPendingLeaves(selectedSicil);
    }
  }, [selectedSicil]);


  const handleOnay = async (id, sicilNo, onayDurumu) => { 
    const actionText = onayDurumu === 1 ? "onaylamak" : "reddetmek";
  
    const confirmAction = window.confirm(`Bu izni ${actionText} istediğinize emin misiniz?`);
    if (!confirmAction) return;
  
    try {
      const response = await fetch(`/izin_karar/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ onay: onayDurumu })
      });
  
      if (!response.ok) throw new Error('Güncelleme başarısız!');
      else window.alert("Karar kaydedildi.");
  
      // Refresh the lists
      fetchLeaveReport(sicilNo);
      fetchPendingLeaves(sicilNo);//setIzinler(izinler.filter(izin => izin.id !== id));
    } catch (error) {
      console.error('Hata:', error);
    }
  };

  return (
    <div>
    <Navbar />
    <div className="container">
      <h2>Personel İzin Raporu</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}

      <label>Personel Seçiniz:</label>
      <select
        value={selectedSicil}
        onChange={(e) => setSelectedSicil(e.target.value)}
        disabled={loading_personnel}
      >
        {loading_personnel?(<option value="">Personel Listesi Yükleniyor...</option>):(<><option value="">-- Seçiniz --</option>
        {personnelList.map((person) => (
          <option key={person.SICIL_NO} value={person.SICIL_NO}>
            {person.ADI_SOYADI}
          </option>
        ))}</>
    )}
      </select>

      {selectedSicil && (
        <>
          <h2>İzin Raporu</h2>
          {loadingLeaveReport?(<p>Rapor yükleniyor... Bekleyiniz...</p>):(leaveReport.length > 0 ? (
            <table className="report-table">
              <thead>
                <tr>

                  <th>İzin Türü</th>
                  <th>Kullanılan</th>
                  <th>Kalan Hak</th>
                </tr>
              </thead>
              <tbody>
                {leaveReport.map((item, index) => (
                  <tr key={index}>
                    
                    <td>{item.ACIKLAMA}</td>
                    <td>{item.TOPLAM_GUN??"-"}</td>
                    <td>{item.KALAN??"-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>Kayıtlı izin bulunamadı.</p>
          ))}
          {pendingLeaves.length > 0 ?(<>
            <h2>Onay Bekleyen İzin Talepleri</h2>
            <table>
              <thead>
                <tr>
                  <th>Sicil No</th>
                  <th>İzin Türü</th>
                  <th>Başlangıç</th>
                  <th>Bitiş</th>
                  <th>Talep Edilen Gün</th>
                  <th>Açıklama/Gerekçe</th>
                  <th>Kayıt Tarihi</th>
                  <th>İşlem</th>
                </tr>
              </thead>
              <tbody>
                {pendingLeaves.map((izin) => (
                  <tr key={izin.ID}>
                    <td>{izin.SICIL_NO}</td>
                    <td>{izin.IZIN_TUR_AD}</td>
                    <td>{new Date(izin.BASLANGIC_TARIH).toLocaleString('tr-TR')}</td>
                    <td>{new Date(izin.BITIS_TARIH).toLocaleString('tr-TR')}</td>
                    <td>{izin.TALEP_GUN}</td>
                    <td>{izin.ACIKLAMA}</td>
                    <td>{new Date(izin.KAYIT_TARIHI).toLocaleString('tr-TR')}</td>
                    <td>
                      <button onClick={() => handleOnay(izin.ID,izin.SICIL_NO, 1)}>✔️ Onayla</button>
                      <button onClick={() => handleOnay(izin.ID,izin.SICIL_NO, 0)}>❌ Reddet</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table></>):(
            <p>Onay bekleyen izin kaydı bulunamadı.</p>
          )
          }
        </>
      )}
    </div>
    </div>
  );
}

export default YonetimPanel;